import React, { useRef, useState } from "react"
import styles from '../Viewer/Viewer.module.css'

const SessionActiveTab = ({ data, sessionIndex, setSessionIndex }) => {
    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        const ele = scrollRef.current;
        setStartX(e.pageX - ele.offsetLeft);
        setScrollLeft(ele.scrollLeft);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const ele = scrollRef.current;
        const x = e.pageX - ele.offsetLeft;
        const walk = (x - startX) * 2;
        ele.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const handleClick = (e, index) => {
        // Only trigger if not dragging
        if (Math.abs(scrollRef.current.scrollLeft - scrollLeft) < 5) {
            setSessionIndex(index);
        }
    };

    return (
        <div
            ref={scrollRef}
            style={{
                display: 'flex',
                gap: '8px',
                overflowX: 'auto',
                paddingBottom: '4px',
                cursor: isDragging ? 'grabbing' : 'grab',
                userSelect: 'none',
                maxWidth: '100%'
            }}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
        >
            {data?.sessions?.map((session, index) => {
                const isActive = index === sessionIndex;

                return (
                    <span
                        key={index}
                        title="Most recent visits"
                        className={`${styles.statsHeader} ${isActive ? styles.active : ''}`}
                        style={{
                            minWidth: '180px',
                            padding: '8px 12px',
                            borderRadius: '5px',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            fontSize: '13px',
                            flexShrink: 0,
                            cursor: 'pointer',
                            fontWeight: isActive ? '600' : '400',
                            opacity: isActive ? '1' : '0.75',
                            border: isActive ? '2px solid var(--btn-primary1)' : '2px solid transparent',
                            transition: 'all 0.2s',
                            backgroundColor: isActive ? 'var(--btn-primary1)' : 'var(--btn-primary)',
                            boxShadow: isActive ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
                        }}
                        onClick={(e) => handleClick(e, index)}
                        onMouseEnter={(e) => {
                            if (!isActive) e.currentTarget.style.opacity = '0.9';
                        }}
                        onMouseLeave={(e) => {
                            if (!isActive) e.currentTarget.style.opacity = '0.75';
                        }}
                    >
                        {session?.date}
                    </span>
                );
            })}
        </div>
    )
}
export default SessionActiveTab